var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "resetPasswordForm",
      staticClass: "w-100 clearfix",
      attrs: { method: "post" }
    },
    [
      _c(
        "div",
        {
          staticClass: "input-feedback-container",
          attrs: { "data-validate": "password" }
        },
        [
          _c(
            "div",
            { staticClass: "input-unit" },
            [
              _c("popper", {
                ref: "passwordHint",
                attrs: { trigger: "focus", placement: "bottom" },
                scopedSlots: _vm._u([
                  {
                    key: "handle",
                    fn: function() {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.passwordFirst,
                              expression: "passwordFirst"
                            }
                          ],
                          attrs: {
                            type: "password",
                            name: "password",
                            autocomplete: "new-password",
                            id: _vm._uid + "password_first"
                          },
                          domProps: { value: _vm.passwordFirst },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.passwordFirst = $event.target.value
                            }
                          }
                        })
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.resetPwPasswordHintTitle"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("ul", { staticClass: "pl-3" }, [
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.resetPwPasswordHintLength"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.resetPwPasswordHintDigit"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.resetPwPasswordHintChar"
                                )
                              )
                            )
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: _vm._uid + "password_first" } }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ceres::Template.resetPwNewPassword")) +
                    "*"
                )
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input-feedback-container",
          attrs: { "data-validate": "ref" }
        },
        [
          _c("div", { staticClass: "input-unit" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.passwordSecond,
                  expression: "passwordSecond"
                }
              ],
              attrs: {
                type: "password",
                name: "password",
                autocomplete: "new-password",
                id: _vm._uid + "password_second",
                "data-validate-ref": "#" + _vm._uid + "password_first"
              },
              domProps: { value: _vm.passwordSecond },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.passwordSecond = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm._uid + "password_second" } }, [
              _vm._v(
                _vm._s(
                  _vm.$translate("Ceres::Template.resetPwRepeatPassword")
                ) + "*"
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-appearance btn-large float-right",
          attrs: { disabled: _vm.isDisabled },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.validatePassword($event)
            }
          }
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$translate("Ceres::Template.resetPwSave")))
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-floppy-o",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }